import { useTranslation } from "react-i18next";
import { Form, Grid, GridColumn } from "semantic-ui-react";

import { createFormHelper } from "lib/Form";

import type { DealerDMSVinaclesConfig } from "models";
import type { AddEditDealerFormPayload } from "modules/DMSv3/Settings/components/AddEditDealerModal";

export type VinaclesConfig = Pick<DealerDMSVinaclesConfig, "client_id" | "client_secret" | "audience" | "api_base_url">;

const FormHelper = createFormHelper<AddEditDealerFormPayload>();

export const VinaclesConfigSection = () => {
  const { t } = useTranslation();

  return (
    <Grid columns="equal">
      <GridColumn>
        <Form.Field>
          <label>{t("v8_client_id", "Client ID")} </label>
          <FormHelper.Field.Input name="vinacles_config.client_id" inputProps={{ fluid: true }} />
        </Form.Field>
      </GridColumn>

      <GridColumn>
        <Form.Field>
          <label>{t("v8_client_secret", "Client Secret")} </label>
          <FormHelper.Field.Input name="vinacles_config.client_secret" inputProps={{ fluid: true }} />
        </Form.Field>
      </GridColumn>

      <GridColumn>
        <Form.Field>
          <label>{t("v8_audience", "Audience")} </label>
          <FormHelper.Field.Input name="vinacles_config.audience" inputProps={{ fluid: true }} />
        </Form.Field>
      </GridColumn>

      <GridColumn>
        <Form.Field>
          <label>{t("v8_api_base_url", "Base URL")} </label>
          <FormHelper.Field.Input name="vinacles_config.api_base_url" inputProps={{ fluid: true }} />
        </Form.Field>
      </GridColumn>
    </Grid>
  );
};
